const defaultState = {
  api_url: undefined,
  api_key: undefined,
  env_id: undefined,
  tenant_id: undefined,
  showSubTenantsId: false,
  subTenantsEnabled: true,
  filter: undefined,
  listener: undefined,
  demo: false,
  corsCheck: false,
  breadcrumbs: true,
  jwtToken: undefined,
  helperText: undefined,
  localization: undefined,
  multipleSources: false,
  hideBackButtons: false,
  connectParams: {},
  multipleTables: false,
  enforceOneToOneMapping: false,
  nextStep: undefined,
  connectionName: undefined,
  credentialsFormValidator: undefined,
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  const { payload, status, type } = action;

  switch (type) {
    case 'INITIALIZE_WIDGET':
      newState = { ...newState, ...payload };
      return newState;

    case 'SET_TENANT':
      newState.tenant_id = String(payload);
      return newState;

    case 'SET_CORS_CHECK':
      newState.corsCheck = payload;
      return newState;

    case 'SET_FILTER':
      newState.filter = payload;
      return newState;

    case 'SET_TOKEN':
      newState.jwtToken = payload;
      return newState;

    case 'SET_LOCALIZATION':
      newState.localization = payload;
      return newState;

    case 'SET_SUBTENANTS_ENABLED':
      newState.subTenantsEnabled = payload;
      return newState

    case 'SET_SHOW_SUB_TENANTS_ID':
      newState.showSubTenantsId = payload;
      return newState

    case 'SET_MULTIPLE_SOURCES':
      newState.multipleSources = payload;
      return newState;

    case 'SET_MULTIPLE_CONNECTORS':
      newState.multipleConnectors = payload
      return newState

    case 'SET_HIDE_BACK_BUTTONS':
      newState.hideBackButtons = payload;
      return newState;

    case 'SET_HIDE_JOB_STATUS_BADGE':
      newState.hideJobStatusBadge = payload;
      return newState;

    case 'SET_LISTENER':
      newState.listener = payload;
      return newState;

    case 'SET_DEMO':
      newState.demo = payload;
      return newState;

    case 'SET_BREADCRUMBS':
      newState.breadcrumbs = payload;
      return newState;

    case 'SET_HELPER_TEXT':
      newState.helperText = payload;
      return newState;

    case 'SET_CONNECT_PARAMS':
      newState.connectParams = payload
      return newState;

    case 'SET_CONNECTION_NAME':
      newState.connectionName = payload
      return newState

    case 'SET_NEXT_STEP':
      newState.nextStep = payload
      return newState;
    
    case 'SET_MULTIPLE_TABLES':
      newState.multipleTables = payload
      return newState;

    case 'SET_ENFORCE_ONE_TO_ONE_MAPPING':
      newState.enforceOneToOneMapping = payload
      return newState;

    case 'SET_CREDENTIALS_FORM_VALIDATOR':
      newState.credentialsFormValidator = payload
      return newState;
  }

  return state;
};
